"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cryptoDestinationFieldFilter = void 0;
/**
 * Filters form fields based on the currency code and whether the currency uses destination tags or memos.
 *
 * @param field - The form field element properties.
 * @param currencyCode - The currency code to check against.
 * @param cryptoWithDestinationTags - Optional array of currency codes that use destination tags.
 * @param cryptoWithDestinationMemo - Optional array of currency codes that use destination memos.
 * @returns A boolean indicating whether the field should be included.
 */
const cryptoDestinationFieldFilter = (field, currencyCode, cryptoWithDestinationTags, cryptoWithDestinationMemo) => {
    const cryptoWithDestinationType = (cryptoWithDestinationTags === null || cryptoWithDestinationTags === void 0 ? void 0 : cryptoWithDestinationTags.includes(currencyCode))
        ? "tags"
        : (cryptoWithDestinationMemo === null || cryptoWithDestinationMemo === void 0 ? void 0 : cryptoWithDestinationMemo.includes(currencyCode))
            ? "memo"
            : undefined;
    if (!currencyCode || (field.name !== "destinationTag" && field.name !== "destinationMemo")) {
        return field.name !== "destinationTag" && field.name !== "destinationMemo";
    }
    return (cryptoWithDestinationType === "tags" && field.name === "destinationTag") ||
        (cryptoWithDestinationType === "memo" && field.name === "destinationMemo");
};
exports.cryptoDestinationFieldFilter = cryptoDestinationFieldFilter;
